"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailAddress$ = exports.CompanyDetailAddress$outboundSchema = exports.CompanyDetailAddress$inboundSchema = void 0;
exports.companyDetailAddressToJSON = companyDetailAddressToJSON;
exports.companyDetailAddressFromJSON = companyDetailAddressFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const companydetailaddressparts_js_1 = require("./companydetailaddressparts.js");
/** @internal */
exports.CompanyDetailAddress$inboundSchema = z.object({
    address_parts: z.nullable(companydetailaddressparts_js_1.CompanyDetailAddressParts$inboundSchema),
    single_line_address: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_parts": "addressParts",
        "single_line_address": "singleLineAddress",
    });
});
/** @internal */
exports.CompanyDetailAddress$outboundSchema = z.object({
    addressParts: z.nullable(companydetailaddressparts_js_1.CompanyDetailAddressParts$outboundSchema),
    singleLineAddress: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressParts: "address_parts",
        singleLineAddress: "single_line_address",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompanyDetailAddress$;
(function (CompanyDetailAddress$) {
    /** @deprecated use `CompanyDetailAddress$inboundSchema` instead. */
    CompanyDetailAddress$.inboundSchema = exports.CompanyDetailAddress$inboundSchema;
    /** @deprecated use `CompanyDetailAddress$outboundSchema` instead. */
    CompanyDetailAddress$.outboundSchema = exports.CompanyDetailAddress$outboundSchema;
})(CompanyDetailAddress$ || (exports.CompanyDetailAddress$ = CompanyDetailAddress$ = {}));
function companyDetailAddressToJSON(companyDetailAddress) {
    return JSON.stringify(exports.CompanyDetailAddress$outboundSchema.parse(companyDetailAddress));
}
function companyDetailAddressFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompanyDetailAddress$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompanyDetailAddress' from JSON`);
}
//# sourceMappingURL=companydetailaddress.js.map